import { TAction, TState } from './WizardProvider.types';
import { ACTION_TYPES } from './WizardProvider.constants';

function wizardReducer(state: TState, action: TAction): TState {
  switch (action.type) {
    case ACTION_TYPES.ADD_MOBILE_TL_INPUTS: {
      return {
        ...state,
        mobileTLInputs: action.payload,
      };
    }
    case ACTION_TYPES.ADD_MOBILE_PACKAGE_INPUTS: {
      return { ...state, mobilePackageInputs: action.payload };
    }
    case ACTION_TYPES.ADD_REFERENCE_ID: {
      return {
        ...state,
        referenceId: action.payload,
      };
    }
    case ACTION_TYPES.ADD_WALLET_GIFT_CODE_INPUTS: {
      return { ...state, walletGiftCodeInputs: action.payload };
    }
    case ACTION_TYPES.CLEAR_MOBILE_TL_INPUTS: {
      return { ...state, mobileTLInputs: action.payload };
    }
    case ACTION_TYPES.CLEAR_MOBILE_PACKAGE_INPUTS: {
      return { ...state, mobilePackageInputs: action.payload };
    }
    case ACTION_TYPES.SET_RAFFLE_LANDING_MODAL_VIEWS_INCREASED: {
      return { ...state, raffleLandingModalViewsIncreased: action.payload };
    }
    case ACTION_TYPES.ADD_PREORDER_ID: {
      return {
        ...state,
        preOrderId: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

export default wizardReducer;
